/**
 * Mock per l'import di `@nestjs/swagger` lato client.
 */
export function ApiProperty(): PropertyDecorator {
  return (target: any) => {};
}
